import { useEffect, useState } from "react";

import TemplateEditor from "../components/TemplateEditor";

import api from "../auth/api";

export default function DashboardApi() {
  const [tokenOk, setTokenOk] = useState(null);
  const [accounts, setAccounts] = useState([]);
  const [selectedAccountId, setSelectedAccountId] = useState("");
  const [phoneId, setPhoneId] = useState("");       // fallback manual para pruebas
  const [to, setTo] = useState("");
  const [freeText, setFreeText] = useState("Hola, gracias por escribirnos. ¿En qué podemos ayudarte?");
  const [tplName, setTplName] = useState("");       // Nombre plantilla Meta (ej: aviso_pago)
  const [vars, setVars] = useState(["Juan", "mañana 10am"]); // Variables para plantilla
  const [sending, setSending] = useState(false);

  // Simula ping rápido al backend para validar conexión
  useEffect(() => {
    const checkApi = async () => {
      try {
        await api.get("/health");  // asumiendo endpoint health
        setTokenOk(true);
      } catch {
        setTokenOk(false);
      }
    };
    checkApi();
    api.get("/wa/accounts")
      .then((r) => {
        const cloud = (r?.data?.rows || []).filter((a) => a.provider === "cloud");
        setAccounts(cloud);
        if (cloud.length) {
          setSelectedAccountId(String(cloud[0].id));
          setPhoneId(String(cloud[0].phone || ""));
        }
      })
      .catch(() => {});
  }, []);

  const sendText = async () => {
    if (!to.trim()) return alert("Ingresa destino (con código país).");
    if (!freeText.trim()) return alert("El texto no puede estar vacío.");
    setSending(true);
    try {
      await api.post("/wa/send-text", {
        to,
        text: freeText,
        wa_account_id: selectedAccountId || undefined,
        phoneId: selectedAccountId ? undefined : phoneId,
      });
      alert("Enviado (texto). Nota: solo entrega si ventana 24h está abierta.");
    } catch (e) {
      alert(JSON.stringify(e?.response?.data || e.message));
    } finally {
      setSending(false);
    }
  };

  const sendTemplate = async () => {
    if (!to.trim() || !tplName.trim()) return alert("Ingresa destino y nombre de plantilla.");
    setSending(true);
    try {
      // Filtra vars nulas y las envía como parámetros de texto
      const parameters = vars
        .filter((v) => v !== null && v !== undefined && v !== "")
        .map((v) => ({ type: "text", text: String(v) }));

      const components = [{ type: "body", parameters }];

      await api.post("/wa/send-template", {
        to,
        wa_account_id: selectedAccountId || undefined,
        phoneId: selectedAccountId ? undefined : phoneId,
        templateName: tplName,
        lang: "es",        // ajustar según plantilla
        components,
      });
      alert("Enviado (plantilla).");
    } catch (e) {
      alert(JSON.stringify(e?.response?.data || e.message));
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <div className="page-title">Pruebas Cloud API</div>
      <section className="card section" style={{ marginBottom: 14 }}>
        <h3 style={{ marginTop: 0 }}>Panel técnico de diagnóstico</h3>
        <p className="muted" style={{ marginBottom: 0 }}>
          Esta pantalla sirve para probar una cuenta WhatsApp Cloud API con un envío puntual.
          Para campañas o lotes usa <b>Campañas &gt; Envíos WhatsApp</b>.
        </p>
      </section>

      <div className="row row-2">
        <section className="card section">
          <h3 style={{ marginTop: 0 }}>Estado</h3>
          <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
            <span
              style={{
                display: "inline-block",
                width: 12,
                height: 12,
                borderRadius: "50%",
                background: tokenOk ? "#22c55e" : "#ef4444",
                border: "2px solid #0f172a",
              }}
            />
            <div>{tokenOk ? "Backend API disponible" : "Sin conexión"}</div>
          </div>
          <div className="row" style={{ marginTop: 12 }}>
            <label>
              Cuenta Cloud
              <select
                className="input"
                value={selectedAccountId}
                onChange={(e) => {
                  const id = e.target.value;
                  setSelectedAccountId(id);
                  const acc = accounts.find((a) => String(a.id) === String(id));
                  setPhoneId(String(acc?.phone || ""));
                }}
              >
                {accounts.length === 0 ? (
                  <option value="">Sin cuentas Cloud</option>
                ) : (
                  accounts.map((a) => (
                    <option key={a.id} value={a.id}>
                      {a.label} · {a.phone}
                    </option>
                  ))
                )}
              </select>
            </label>
            <label>
              PHONE_NUMBER_ID manual
              <input
                className="input"
                value={phoneId}
                onChange={(e) => setPhoneId(e.target.value)}
                placeholder="Ej: 123456789012345"
                disabled={!!selectedAccountId}
              />
            </label>
          </div>
        </section>

        <section className="card section">
          <h3 style={{ marginTop: 0 }}>Destino</h3>
          <div className="row">
            <label>
              Enviar a (E.164 sin +)
              <input
                className="input"
                value={to}
                onChange={(e) => setTo(e.target.value)}
                placeholder="5939xxxxxxx"
              />
            </label>
          </div>
        </section>
      </div>

      <section className="card section">
        <h3 style={{ marginTop: 0 }}>Enviar texto libre (solo ventana 24h)</h3>
        <TemplateEditor template={freeText} setTemplate={setFreeText} compact />
        <button className="btn btn-primary" onClick={sendText} disabled={sending}>
          Enviar texto
        </button>
        <div style={{ fontSize: 12, color: "var(--muted)", marginTop: 6 }}>
          Meta solo permite texto libre si el cliente escribió recientemente y la conversación sigue dentro de la ventana de atención. No usar esta opción para masivos.
        </div>
      </section>

      <section className="card section">
        <h3 style={{ marginTop: 0 }}>Probar plantilla aprobada de Meta</h3>
        <div className="row row-3">
          <label>
            Nombre de plantilla (Meta)
            <input
              className="input"
              value={tplName}
              onChange={(e) => setTplName(e.target.value)}
              placeholder="aviso_pago"
            />
          </label>
          <label>
            Variable {`{{1}}`}
            <input
              className="input"
              value={vars[0] || ""}
              onChange={(e) => {
                const v = [...vars];
                v[0] = e.target.value;
                setVars(v);
              }}
              placeholder="Juan"
            />
          </label>
          <label>
            Variable {`{{2}}`}
            <input
              className="input"
              value={vars[1] || ""}
              onChange={(e) => {
                const v = [...vars];
                v[1] = e.target.value;
                setVars(v);
              }}
              placeholder="Mañana 10am"
            />
          </label>
        </div>
        <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
          <button className="btn btn-primary" onClick={sendTemplate} disabled={sending}>
            Enviar plantilla
          </button>
        </div>
        <div style={{ fontSize: 12, color: "var(--muted)", marginTop: 6 }}>
          Las plantillas se crean desde Plantillas de envío o en Meta Business Manager, y deben estar aprobadas por Meta.
          Las variables son posicionales ({`{{1}}`}, {`{{2}}`}...). Para lotes masivos usa Envíos WhatsApp.
        </div>
      </section>
    </>
  );
}
